import { ncFileStatuses } from '@helpers';
import { LinkStatus } from '@interfaces/search';

export const LINK_STATUS_ICON = {
  [LinkStatus.NOT_LINKED]: 'notLinked',
  [LinkStatus.SINGLE_LINK]: 'linked',
  [LinkStatus.MULTI_LINK]: 'multiLink',
  [LinkStatus.PARTIAL_LINK]: undefined,
} as const;

export const NC_FILE_STATUS = {
  Ignored: 'crossedBell',
  Unknown: 'unknownLink',
  Linked: 'ncFileLinked',
  Change: 'loopedArrows',
  Setup: 'setup',
} as const;

const NC_FILE_STATUS_ICON_COLOR: Partial<Record<keyof typeof NC_FILE_STATUS, string>> = {
  Setup: 'Status/Light/Setup',
};

export function resolveLinkIconColor(ncFileStatus: keyof typeof NC_FILE_STATUS): string | undefined {
  return NC_FILE_STATUS_ICON_COLOR[ncFileStatus];
}

interface ResolveLinkIconParams {
  linkStatus: keyof typeof LINK_STATUS_ICON;
  ncFileStatus: keyof typeof NC_FILE_STATUS;
  isWithERP: boolean;
  takeIntoAccountOnlyNcFileStatus?: boolean;
}

export function resolveLinkIcon({ linkStatus, ncFileStatus, isWithERP, takeIntoAccountOnlyNcFileStatus }: ResolveLinkIconParams): string | null {
  if (!linkStatus && !ncFileStatus) return null;

  if (takeIntoAccountOnlyNcFileStatus) {
    if (ncFileStatus === ncFileStatuses.Linked) {
      return LINK_STATUS_ICON.SingleLink;
    }
    return NC_FILE_STATUS[ncFileStatus];
  }

  if (!LINK_STATUS_ICON[linkStatus] && ncFileStatus === ncFileStatuses.Linked && !isWithERP) {
    return LINK_STATUS_ICON.SingleLink;
  }

  if ([ncFileStatuses.Unknown, ncFileStatuses.Ignored, ncFileStatuses.Setup].includes(ncFileStatus)) {
    return NC_FILE_STATUS[ncFileStatus];
  }

  return LINK_STATUS_ICON[linkStatus] || NC_FILE_STATUS[ncFileStatus] || 'unknownLink';
}
